import { ChainId } from '@pancakeswap/sdk'

// ===== Updated ENDPOINTS =====
export const INFO_CLIENT =
  'https://indexer.potatoswap.finance/subgraphs/id/Qmdbeo7H5A36ygaVksgM9UkLvdRPjy9eB4gYUYQPLo7eDq'
export const INFO_CLIENT_X_LAYER = INFO_CLIENT
export const LANDING_QUERY = INFO_CLIENT

// ===== Previews ENDPOINTS =====

export const GRAPH_API_PROFILE = 'https://api.thegraph.com/subgraphs/name/pancakeswap/profile'
export const GRAPH_API_PREDICTION_BNB = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction-v2'
export const GRAPH_API_PREDICTION_CAKE = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction-cake'

export const GRAPH_API_LOTTERY = 'https://api.thegraph.com/subgraphs/name/pancakeswap/lottery'
export const SNAPSHOT_BASE_URL = process.env.NEXT_PUBLIC_SNAPSHOT_BASE_URL
export const API_PROFILE = 'https://profile.pancakeswap.com'
export const API_NFT = 'https://nft.pancakeswap.com/api/v1'
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`
export const GRAPH_API_POTTERY = 'https://api.thegraph.com/subgraphs/name/pancakeswap/pottery'

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const GRAPH_API_PREDICTION_V1 = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction'

export const INFO_CLIENT_ETH = 'https://api.thegraph.com/subgraphs/name/pancakeswap/exhange-eth'
export const INFO_CLIENT_X1 = 'https://www.okx.com/api/v1/x1-testnet/index/subgraphs/name/Potato-subgraph-v4'
export const BLOCKS_CLIENT = 'https://api.studio.thegraph.com/query/71529/blocks_xlayer/version/latest'
export const BLOCKS_CLIENT_ETH = 'https://api.thegraph.com/subgraphs/name/blocklytics/ethereum-blocks'
export const BLOCKS_CLIENT_X1 = 'https://www.okx.com/api/v1/x1-testnet/index/subgraphs/name/blocks-subgraph'
export const BLOCKS_CLIENT_X_LAYER = 'https://api.studio.thegraph.com/query/71529/blocks_xlayer/version/latest'
export const STABLESWAP_SUBGRAPH_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-stableswap'
export const GRAPH_API_NFTMARKET = 'https://api.thegraph.com/subgraphs/name/pancakeswap/nft-market'
export const GRAPH_HEALTH = 'https://api.thegraph.com/index-node/graphql'

export const TC_MOBOX_SUBGRAPH = 'https://api.thegraph.com/subgraphs/name/pancakeswap/trading-competition-v3'
export const TC_MOD_SUBGRAPH = 'https://api.thegraph.com/subgraphs/name/pancakeswap/trading-competition-v4'

export const FARM_API = 'https://farms-api.pancakeswap.com'

export const BIT_QUERY = 'https://graphql.bitquery.io'

export const ACCESS_RISK_API = '/api/risk'

export const CELER_API = 'https://api.celerscan.com/scan'

export const INFO_CLIENT_WITH_CHAIN = {
  [ChainId.BSC]: INFO_CLIENT,
  [ChainId.ETHEREUM]: INFO_CLIENT_ETH,
  [ChainId.X1_TESTNET]: INFO_CLIENT_X1,
  [ChainId.X_LAYER]: INFO_CLIENT_X_LAYER,
}

export const BLOCKS_CLIENT_WITH_CHAIN = {
  [ChainId.BSC]: BLOCKS_CLIENT,
  [ChainId.ETHEREUM]: BLOCKS_CLIENT_ETH,
  [ChainId.X1_TESTNET]: BLOCKS_CLIENT_X1,
  [ChainId.X_LAYER]: BLOCKS_CLIENT_X_LAYER,
}

export const ASSET_CDN = 'https://assets.pancakeswap.finance'

export const TRADING_REWARD_API = 'https://pancake-trading-fee-rebate-api.pancake.run/api/v1'
